exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.component-root[data-v-c392aa82] {\n    display: flex;\n    flex-flow: column;\n    row-gap: 10px;\n}\n", ""]);

